import React from 'react';
import { ConfigProvider } from 'antd';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import ComponentVersionRoute from './components/ComponentVersionRoute';
import AppLayout from './components/AppLayout';
import Dashboard from './pages/Dashboard';
import VersionList from './pages/VersionList';
import VersionUpload from './pages/VersionUpload';
import VersionDetail from './pages/VersionDetail';
import ComponentVersions from './pages/ComponentVersions';
import Waveforms from './pages/Waveforms';
import StaffList from './pages/StaffList';
import DeviceManagement from './pages/DeviceManagement';
import AuditLog from './pages/AuditLog';
import Login from './pages/Login';
import { WELZEK_THEME } from './theme';
import './App.css';

function App() {
  return (
    <ConfigProvider theme={WELZEK_THEME}>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={(
              <ProtectedRoute>
                <AppLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/versions" element={<VersionList />} />
                    <Route path="/versions/release" element={<VersionList />} />
                    <Route path="/versions/daily" element={<VersionList />} />
                    <Route path="/versions/market" element={<VersionList />} />
                    <Route path="/versions/components" element={<ComponentVersionRoute><ComponentVersions /></ComponentVersionRoute>} />
                    <Route path="/waveforms" element={<Waveforms />} />
                    <Route path="/upload" element={<AdminRoute><VersionUpload /></AdminRoute>} />
                    <Route path="/versions/:id" element={<VersionDetail />} />
                    <Route path="/staff" element={<AdminRoute><StaffList /></AdminRoute>} />
                    <Route path="/devices" element={<AdminRoute><DeviceManagement /></AdminRoute>} />
                    <Route path="/audit-logs" element={<AdminRoute><AuditLog /></AdminRoute>} />
                  </Routes>
                </AppLayout>
              </ProtectedRoute>
            )}
          />
        </Routes>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
